function Footer() {
  return (
    <footer className="bg-blue-500 p-4 text-center text-white">
      <p>© {new Date().getFullYear()} Badkul Technology JSON Formatter. All rights reserved.</p>
    </footer>
  )
}

export default Footer
